import { useEffect } from 'react';

/**
 * Custom hook to dynamically manage document title and meta description.
 * Useful for SEO in an SPA environment where the router changes content without reload.
 */
export function useSEO(title: string, description?: string) {
    useEffect(() => {
        // Backup original values so we can revert when the component unmounts
        const originalTitle = document.title;
        const metaDescription = document.querySelector('meta[name="description"]');
        const originalDescription = metaDescription ? metaDescription.getAttribute('content') : '';

        // Update values
        document.title = title;
        if (description && metaDescription) {
            metaDescription.setAttribute('content', description);
        }

        // Cleanup function
        return () => {
            document.title = originalTitle;
            if (metaDescription && originalDescription !== null) {
                metaDescription.setAttribute('content', originalDescription);
            }
        };
    }, [title, description]);
}
